/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UserPersonErasureResponse
 */
export interface UserPersonErasureResponse {
    /**
     * 
     * @type {boolean}
     * @memberof UserPersonErasureResponse
     */
    success?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UserPersonErasureResponse
     */
    personGoldenId?: string;
    /**
     * 
     * @type {number}
     * @memberof UserPersonErasureResponse
     */
    observationsErased?: number;
    /**
     * 
     * @type {string}
     * @memberof UserPersonErasureResponse
     */
    errorMessage?: string;
}

/**
 * Check if a given object implements the UserPersonErasureResponse interface.
 */
export function instanceOfUserPersonErasureResponse(value: object): value is UserPersonErasureResponse {
    return true;
}

export function UserPersonErasureResponseFromJSON(json: any): UserPersonErasureResponse {
    return UserPersonErasureResponseFromJSONTyped(json, false);
}

export function UserPersonErasureResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UserPersonErasureResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'success': json['success'] == null ? undefined : json['success'],
        'personGoldenId': json['personGoldenId'] == null ? undefined : json['personGoldenId'],
        'observationsErased': json['observationsErased'] == null ? undefined : json['observationsErased'],
        'errorMessage': json['errorMessage'] == null ? undefined : json['errorMessage'],
    };
}

export function UserPersonErasureResponseToJSON(json: any): UserPersonErasureResponse {
    return UserPersonErasureResponseToJSONTyped(json, false);
}

export function UserPersonErasureResponseToJSONTyped(value?: UserPersonErasureResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'success': value['success'],
        'personGoldenId': value['personGoldenId'],
        'observationsErased': value['observationsErased'],
        'errorMessage': value['errorMessage'],
    };
}

